export default {
  path: '/alarms/tracking/:id',
  name: 'AlarmView',
  component: () => import(/* webpackChunkName: "administration" */ '../views/AlarmView.vue')
}
